export default __webpack_public_path__ + "static/media/spear.ba5c0020.svg";